import { ToastType } from "../../types";
import { brand as _brandManifest } from "../../branding/generated/brand-manifest";

export type ToastMessagesType = {
  [key: string]: {
    message: string;
    messageTitle: string;
  };
};

export const Messages: ToastMessagesType = {
  "traveller.info.firstname.placeholder": {
    message: "Enter first name",
    messageTitle: "",
  },
  "traveller.info.middlename.placeholder": {
    message: "Enter middle name (if applicable)",
    messageTitle: "",
  },
  "traveller.info.lastname.placeholder": {
    message: "Enter last name",
    messageTitle: "",
  },
  "traveller.info.passport.number.placeholder": {
    message: "Enter passport number",
    messageTitle: "",
  },
  "traveller.info.frequent.flyer.number.placeholder": {
    message: "Enter frequent flyer number",
    messageTitle: "",
  },
  "traveller.info.tsa.placeholder": {
    message: "Enter TSA Precheck number",
    messageTitle: "",
  },
  "traveller.info.redress.number.placeholder": {
    message: "Enter redress number",
    messageTitle: "",
  },

  "trip.help.emailId": {
    message: "support@zenvoya.ai",
    messageTitle: "Email Us",
  },
  "trip.help.email.subject": {
    message: "Need help with Booking",
    messageTitle: "",
  },
  "trip.help.phone.number": {
    message: "+1 (703) 952-5090",
    messageTitle: "8am - 8pm EST",
  },
  "trip.help.phone.number.secondary": {
    message: "+1 (855) 566-5001",
    messageTitle: "8am - 8pm EST",
  },
  "trip.help.chat": {
    message: "Chat with us",
    messageTitle: "8am - 8pm EST",
  },

  "trip.help.header": {
    message: "Trip Help",
    messageTitle: "8am - 8pm EST",
  },
  "askzoya.view.details.btn": {
    message: "View Details",
    messageTitle: "",
  },
  "ask.zoya.enable": {
    message: "ENABLE_ZOYA",
    messageTitle: "",
  },
  "askzoya.chat.input.placeholder": {
    message: "Ask anything travel",
    messageTitle: "",
  },
  "askzoya.follow.up.info": {
    message: `Hi! I'm ${_brandManifest.assistantName}.`,
    messageTitle:
      "Ask me anything about these results - I can help you compare, explain, or pick the best option based on your needs",
  },
  "askzoya.followup.prompt": {
    message: "Please provide 4 followup questions",
    messageTitle: "",
  },
  "share.via.email.failure.400": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.401": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.402": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.403": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists..",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.404": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.500": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.501": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.502": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists..",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.503": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "share.via.email.failure.504": {
    message:
      "Sorry, we are unable to process your request. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "beta.info": { message: `${_brandManifest.name} is in beta — we are still fine tuning results!`, messageTitle: "" },
  //booking heading
  "timeOutError.refresh.results": {
    messageTitle: "We couldn't get the latest deals in time. ",
    message: "Please try again in a few moments.",
  },

  "flight.cancellation": {
    message: "Free cancellation within 24 hours of booking.",
    messageTitle: "",
  },

  // Shop results row (HotelFilterEntry / FlightFilterEntry / ActivityFilterEntry):
  // heading + the count line under it (see flightFilters/ResultsTitle.tsx).
  "results.heading.stays": { message: "Available stays", messageTitle: "" },
  "results.heading.flights": { message: "Available flights", messageTitle: "" },
  "results.heading.activities": { message: "Available activities", messageTitle: "" },
  "results.count.one": { message: "{count} option", messageTitle: "" },
  "results.count.many": { message: "{count} options", messageTitle: "" },
  "results.count.capped": { message: "{count}+ options", messageTitle: "" },

  "refresh.flight.results": {
    message: "Let’s refresh to find you the best current deals",
    messageTitle: "Looks like these results are a bit old",
  },
  "refresh.stay.results": {
    message: "Let’s refresh to find you the best current deals",
    messageTitle: "Looks like these results are a bit old",
  },
  "expired.flight.results": {
    messageTitle: "Your results are expired",
    message: "These flight results are more than 30 minutes old. Refresh to get the latest options and prices.",
  },
  "expired.stay.results": {
    messageTitle: "Your results are expired",
    message: "These hotel results are more than 30 minutes old. Refresh to get the latest options and prices.",
  },
  "booking.session.expired": {
    messageTitle: "Your booking session expired",
    message: "Please start your booking again.",
  },
  "booking.header.flight.stays": {
    message: "Search Flights & Stays",
    messageTitle: "",
  },
  "flight.available.success": {
    message: "Let’s search for Stays now!",
    messageTitle: "Your flights were added to the cart.",
  },
  "flight.search.messages": {
    message:
      "Getting your plans ready..., Finding the best options..., You're almost ready to take off!, Hang tight! Finalizing your trip...",
    messageTitle: "",
  },
  "itinerary.save.loading.messages": {
    message: "Saving itinerary...",
    messageTitle: "",
  },
  "itinerary.search.messages": {
    message:
      "Getting your plans ready..., Finding the best options..., You're almost ready to take off!, Hang tight! Finalizing your trip...",
    messageTitle: "",
  },
  "bookclick.search.messages": {
    message:
      "Getting your plans ready..., Finding the best options..., You're almost ready to take off!, Hang tight! Finalizing your trip...",
    messageTitle: "",
  },
  "booking.review": {
    message: "Review Your Trip",
    messageTitle: "24x7 support available",
  },
  "booking.traveler.info": {
    message: "Who's Traveling?",
    messageTitle: "Secure booking - only takes a few minutes!",
  },
  "checkout.stays.title": {
    message: "Stays",
    messageTitle: "",
  },
  "checkout.travelers.flight.title": {
    message: "Flight Travelers",
    messageTitle: "",
  },
  "checkout.travelers.stay.title": {
    message: "Stay Info",
    messageTitle: "",
  },
  "checkout.room.assignment.title": {
    message: "Room Assignment",
    messageTitle: "",
  },
  "checkout.whats.this.for": {
    message: "What’s this for?",
    messageTitle: "",
  },
  "checkout.payment.title": {
    message: "Payment Method",
    messageTitle: "",
  },
  "checkout.total.due": {
    message: "Total due",
    messageTitle: "",
  },
  "checkout.cancellation.policy": {
    message: "Cancellation policy",
    messageTitle: "",
  },
  "mcp.detail.book": {
    message: "Book",
    messageTitle: "",
  },
  "mcp.expired.flight.results": {
    messageTitle: "Your results are expired",
    message: "These flight results are more than 15 minutes old. Refresh to get the latest options and prices.",
  },
  "mcp.expired.stay.results": {
    messageTitle: "Your results are expired",
    message: "These hotel results are more than 15 minutes old. Refresh to get the latest options and prices.",
  },
  "mcp.expired.activity.results": {
    messageTitle: "Your results are expired",
    message: "These activity results are more than 15 minutes old. Refresh to get the latest options and prices.",
  },
  "mcp.book.failed": {
    messageTitle: "We couldn't continue to checkout",
    message: "Please try again.",
  },
  "checkout.review.remove": {
    message: "Remove",
    messageTitle: "",
  },
  "checkout.review.modify": {
    message: "Modify",
    messageTitle: "",
  },
  "traveller.info.invalid.date": {
    message: "Invalid Date of Birth. Please enter correct Date and try again!",
    messageTitle: "",
  },

  //Promo code
  "missing.promo.payment.details": {
    message: "OOPS",
    messageTitle: "Payment details missing",
  },
  "empty.promo.code": {
    message: "OOPS",
    messageTitle: "Please enter a promo code",
  },
  "failed.to.apply.promo.code": {
    message: "Failed to apply promo code. Please try again.",
    messageTitle: "OOPS",
  },
  "failed.to.remove.promo.code": {
    message: "Failed to remove promo code. Please try again.",
    messageTitle: "OOPS",
  },
  "promo.code.remove.success": {
    message: "Promo code removed successfully",
    messageTitle: "Success",
  },
  "promo.code.failure.400": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.401": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.402": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.403": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.404": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.500": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.501": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.502": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.503": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "promo.code.failure.504": {
    message:
      "Sorry, we are unable to precess your request at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  //flight search
  "flight.availability.loader": {
    message: "Checking flight availability",
    messageTitle: "",
  },
  "flight.availability.failure": {
    message: "Selected flight is no longer available. Please select another flight or search again!",
    messageTitle: "Sorry",
  },
  "flight.continue.loader": {
    message: "Next, let's search for hotels",
    messageTitle: "",
  },
  "flight.selected.loader": {
    message: "Flight added to your cart.",
    messageTitle: "",
  },
  "flight.details.loader": {
    message: "Checking flight details",
    messageTitle: "",
  },
  "flight.not.available.loader": {
    message: "No flights available for your dates",
    messageTitle: "Please try another date",
  },
  "baggage.and.fare.rules.loader": {
    message: "Fetching baggage and fare rules",
    messageTitle: "",
  },
  "flight.search.failure.400": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.401": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.402": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.403": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.404": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.500": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.501": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.502": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.503": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.search.failure.504": {
    message: "Sorry, our system is too busy at this time to search for flights. Please try again later.",
    messageTitle: "OOPS",
  },
  "airline.search.error": {
    message: "Failed to fetch airline preferences.",
    messageTitle: "OOPS",
  },
  "no.flights.found": {
    messageTitle: "Sorry",
    message: "No flights found",
  },
  "prebooking.failure.504": {
    message: "Sorry, our system is too busy at this time to search for hotel rooms. Please try again later.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.400": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.401": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "ERROR!",
  },
  "hotel.search.rooms.failure.402": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.403": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.404": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "ERROR!",
  },
  "hotel.search.rooms.failure.500": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.501": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.502": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.503": {
    message:
      "Sorry, we are unable to search for hotel rooms at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.rooms.failure.504": {
    message: "Sorry, our system is too busy at this time to search for hotel rooms. Please try again later.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.503": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.502": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.501": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.500": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.400": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.401": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "ERROR!",
  },
  "prebooking.failure.402": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.403": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prebooking.failure.404": {
    message:
      "Sorry, we are unable to book flights or hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "ERROR!",
  },

  //Dialog messages

  "traveler.info.dialog": {
    messageTitle: "What’s Traveler Info for?",
    message:
      "Traveler details help us book and confirm your trip with airlines and hotels. Your information is securely encrypted and protected at every step.",
  },
  "modify.flight.dialog": {
    messageTitle: "Modify flights",
    message: "To modify flight, you will go back to search. Do you want to do that?",
  },
  "modify.stay.dialog": {
    messageTitle: "Modify stays",
    message: "To modify stay, you will go back to search. Do you want to do that?",
  },
  "modify.flight.dialog.payment": {
    messageTitle: "",
    message:
      "To modify flight, you will be directed back to the search page. Price and availability may change. Do you want to continue?",
  },
  "modify.stay.dialog.payment": {
    messageTitle: "",
    message:
      "To modify stay, you will be directed back to the search page. Price and availability may change. Do you want to continue?",
  },

  "edit.traveler.dialog": {
    messageTitle: "Edit travelers",
    message: "Updating traveler details may refresh prices and availability of your trip. Do you want to continue?",
  },

  "price.change.dialog": {
    messageTitle: "Price changed",
    message: "The new price for your flight / stay is $1,000. Would you like to accept the price change?",
  },

  "leave.flight.dialog": {
    messageTitle: "Are you sure you want to leave?",
    message: "The current price and availability of your flight and stay might change after you come back.",
  },
  "seat.notAvailable.dialog": {
    messageTitle: "Seat no longer available",
    message: "To modify flight, you will go back to search. Do you want to do that?",
  },
  "data.security.dialog": {
    messageTitle: "How is my data secured?",
    message: "Educate about data security",
  },
  //flight availability

  "flight.availability.failure.400": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.401": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.402": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.403": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.404": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.500": {
    message:
      "Sorry, we are unable to search for flights at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.501": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.502": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.503": {
    message:
      "Sorry, we are unable to get flight availability details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.availability.failure.504": {
    message: "Sorry, our system is too busy at this time to search for flights. Please try again later.",
    messageTitle: "OOPS",
  },

  // flight details
  "flight.detail.failure.400": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.401": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.402": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.403": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.404": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.500": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.501": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.502": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.503": {
    message:
      "Sorry, we are unable to display flight details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "flight.detail.failure.504": {
    message: "Sorry, our system is too busy to display flight details. Please try again later.",
    messageTitle: "OOPS",
  },
  "discard.changes": {
    message: "Discarding changes will result in losing your modifications",
    messageTitle: "",
  },
  //getHelp
  "get.help.success": {
    message: "Request submitted successfully!",
    messageTitle: "Success!",
  },
  "get.help.invalid.phone.number": {
    message: "Please enter valid phone number",
    messageTitle: "",
  },
  //booking input fields
  //booking hotel input fields
  "hotel.search.loader": {
    message: "Searching for stays",
    messageTitle: "",
  },
  "stay.search.messages": {
    message:
      "Tapping into live travel deals..., Checking what's available right now..., Handpicking options that match your vibe..., Making sure we didn't miss anything great..., Still on it! Live deals are rolling in..., Finalizing your top picks...",
    messageTitle: "",
  },
  "hotel.details.loader": {
    message: "Fetching stays details",
    messageTitle: "",
  },
  "loader.wait": {
    message: "Please wait",
    messageTitle: "",
  },
  "hotel.location.input.field": {
    message: "Enter property name, city, neighbourhood or address",
    messageTitle: "",
  },
  "hotel.location.input.label": {
    message: "Location",
    messageTitle: "",
  },
  "hotel.location.reselect": {
    messageTitle: "Please select your stay location",
    message: "We couldn't verify that location. Search and select it again to continue.",
  },
  "hotel.date.range.input.field.label": {
    message: "Check out",
    messageTitle: "Check in",
  },
  "booking.hotel.check.in.date": {
    message: "Please select a check-in date",
    messageTitle: "",
  },
  "booking.hotel.check.out.date": {
    message: "Please select a check-out date",
    messageTitle: "",
  },
  "booking.hotel.check.out.date.notsame": {
    message: "Checkout date should be after the check-in date",
    messageTitle: "",
  },
  //hotel search
  "hotel.brand.search.error": {
    message: "Failed to fetch stay preferences.",
    messageTitle: "OOPS",
  },

  "hotel.search.invalid.city": {
    message: "Please enter a cities to search",
    messageTitle: "",
  },
  "hotel.search.failure.400": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.401": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.402": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.403": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.404": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.409": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.422": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.500": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.501": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.502": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.503": {
    message:
      "Sorry, we are unable to search for hotels at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.search.failure.504": {
    message: "Sorry, our system is too busy at this time to search for hotels. Please try again later.",
    messageTitle: "OOPS",
  },
  "invalid.room.info": {
    message: "OPPS",
    messageTitle: "Please enter required fields",
  },

  "no.hotels.found.screen.message": {
    messageTitle: "Sorry",
    message: "No stays found",
  },

  // hotel detail
  "hotel.detail.failure.400": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.401": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.402": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.403": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.404": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.500": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.501": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.502": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.503": {
    message:
      "Sorry, we are unable to display hotel details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "hotel.detail.failure.504": {
    message: "Sorry, our system is too busy to display hotel details. Please try again later.",
    messageTitle: "OOPS",
  },

  // booked trip details
  "trip.summary.failure.409": {
    message:
      "Sorry, we are unable to fetch the details of your booked trip at this time due to a conflict. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.400": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.401": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.402": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.403": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.404": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.500": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.501": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.502": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.503": {
    message:
      "Sorry, we are unable to fetch the payment details of your booked trip at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "trip.summary.failure.504": {
    message: "Sorry, our system is too busy at this time to get payment details. Please try again later.",
    messageTitle: "OOPS",
  },

  //user detail

  "user.delete.failure": {
    message: "Unable to delete the user",
    messageTitle: "OOPS",
  },
  "user.delete.success": {
    message: "User deleted",
    messageTitle: "",
  },
  "user.detail.failure.400": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.401": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.402": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.403": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.404": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.500": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.501": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.502": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.503": {
    message:
      "Sorry, we are unable to display user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.detail.failure.504": {
    message: "Sorry, our system is too busy to display user details. Please try again later.",
    messageTitle: "OOPS",
  },
  "cannot.fetch.user.details": {
    message: "Cannot fetch user details.",
    messageTitle: "",
  },

  //update user details
  "user.update.failure.400": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.update.failure.401": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.update.failure.402": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.update.failure.403": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.update.failure.404": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.update.failure.500": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.update.failure.501": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.update.failure.502": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.update.failure.503": {
    message:
      "Sorry, we are unable to update user details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.update.failure.504": {
    message: "Sorry, our system is too busy to update user details. Please try again later.",
    messageTitle: "OOPS",
  },
  // create user

  "user.create.failure.400": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.create.failure.401": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.create.failure.402": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.create.failure.403": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.create.failure.404": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "user.create.failure.500": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.create.failure.501": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.create.failure.502": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.create.failure.503": {
    message:
      "Sorry, we are unable to create user at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "user.create.failure.504": {
    message: "Sorry, our system is too busy to create user details. Please try again later.",
    messageTitle: "OOPS",
  },

  // user.login
  "loggout.failure.message": {
    message: "Logout failed. Please try again",
    messageTitle: "OOPS",
  },
  "user.login.failure.400": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.401": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.402": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.403": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.404": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.500": {
    message: "Sorry, we were unable to log you in. Please try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.501": {
    message: "Sorry, we were unable to log you in. Please try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.502": {
    message: "Sorry, we were unable to log you in. Please try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.503": {
    message: "Sorry, we were unable to log you in. Please try again.",
    messageTitle: "OOPS",
  },
  "user.login.failure.504": {
    message: "Sorry, our system is too busy to log you in. Please try again later.",
    messageTitle: "OOPS",
  },

  // user.logout

  "user.logout.failure.400": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.401": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.402": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.403": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.404": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.500": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.501": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.502": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.503": {
    message: "Sorry, we couldn't log you out. Please try again.",
    messageTitle: "OOPS",
  },
  "user.logout.failure.504": {
    message: "Sorry, our system is too busy to log you out. Please try again later.",
    messageTitle: "OOPS",
  },

  // reset.password

  "reset.password.failure.400": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.401": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.402": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.403": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.404": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.500": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.501": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.502": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.503": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.password.failure.504": {
    message: "Sorry, our system is too busy to reset your password. Please try again later.",
    messageTitle: "OOPS",
  },

  // reset.passwordlink

  "reset.passwordlink.failure.400": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.401": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.402": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.403": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.404": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.500": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.501": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.502": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.503": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "reset.passwordlink.failure.504": {
    message: "Sorry, our system is too busy to reset your password. Please try again later.",
    messageTitle: "OOPS",
  },

  //user.sendpasswordlink

  "user.sendpasswordlink.failure.400": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.401": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.402": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.403": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.404": {
    message: "We couldn't find your account. Please check your information and try again.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.500": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.501": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.502": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.503": {
    message: "Sorry, we couldn't reset your password. Please try again later.",
    messageTitle: "OOPS",
  },
  "user.sendpasswordlink.failure.504": {
    message: "Sorry, our system is too busy to reset your password. Please try again later.",
    messageTitle: "OOPS",
  },

  //onboarding preference
  "onboarding.preference.label": {
    message: "You can change this later",
    messageTitle: "",
  },
  "onboarding.welcome": {
    message: `Welcome to ${_brandManifest.name}!`,
    messageTitle: "Let's plan your next trip.",
  },
  "onboarding.home": {
    message: "What's your home city?",
    messageTitle: "",
  },
  "onboarding.travelWith": {
    message: "Who do you travel with?",
    messageTitle: "",
  },
  "onboarding.lookingFor": {
    message: "What is the vibe you look for?",
    messageTitle: "",
  },
  "onboarding.budget": {
    message: "How do you budget?",
    messageTitle: "",
  },
  "onboarding.singup.label": {
    message: "Create an account to enjoy:",
    messageTitle: "Almost there!",
  },
  //preference

  "refundable.drop.down.label": {
    message: "Refundable",
    messageTitle: "",
  },
  "user.rating.drop.down.label": {
    message: "User Rating",
    messageTitle: "",
  },
  "connections.drop.down.label": {
    message: "Connections",
    messageTitle: "",
  },
  "departure.drop.down.label": {
    message: "Departure",
    messageTitle: "",
  },
  "arrival.times.label": {
    message: "Arrival",
    messageTitle: "",
  },
  "preference.about.placeholder": {
    message: "Tell us about your flight, stay and other trip preferences here",
    messageTitle: "",
  },
  // Keep the number in sync with ABOUT_ME_MAX_LENGTH (src/constant/common.ts).
  // Voice matches the traveler-form length errors ("First name too long (max 28 exceeded)").
  "preference.about.max.length": {
    message: "Preferences too long (max 2000 exceeded)",
    messageTitle: "",
  },
  "my.home.city.label": {
    message: "My home city:",
    messageTitle: "",
  },
  "my.home.city.placeholder": {
    message: "Enter city name",
    messageTitle: "",
  },
  "preference.update.success": {
    message: "Your preferences are updated!",
    messageTitle: "",
  },
  "preference.add.success": {
    message: "Your preferences are added!",
    messageTitle: "",
  },
  "memory.save.success": {
    message: "Saved to your memory.",
    messageTitle: "",
  },
  "memory.remove.success": {
    message: "Removed from your memory.",
    messageTitle: "",
  },
  "memory.restore.success": {
    message: "Restored from your history.",
    messageTitle: "",
  },
  "memory.save.failure": {
    message: "Sorry, we couldn't save this change. Please try again.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.400": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.401": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.402": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.403": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.404": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.500": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.501": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.502": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.503": {
    message:
      "Sorry, we are unable to display your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.details.failure.504": {
    message: "Sorry, our system is too busy to view your preferences. Please try again later.",
    messageTitle: "OOPS",
  },
  // preference update
  "preference.update.failure.400": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.401": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.402": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.403": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.404": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.500": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.501": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.502": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.503": {
    message:
      "Sorry, we are unable to update your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "preference.update.failure.504": {
    message: "Sorry, our system is too busy to update your preferences. Please try again later.",
    messageTitle: "OOPS",
  },
  //traveller info
  "traveler.info.heading": {
    message: "Basic Information",
    messageTitle: "",
  },
  "traveller.info.name.input.label": {
    message: "First Name",
    messageTitle: "",
  },
  "traveller.info.middle.input.label": {
    message: "Middle Name (Optional)",
    messageTitle: "",
  },
  "traveler.infoId.placeholder": {
    message: "(if shown on ID)",
    messageTitle: "",
  },
  "traveler.info.hotel.id.placeholder": {
    message: "Optional",
    messageTitle: "",
  },
  "traveller.info.last.input.label": {
    message: "Last Name",
    messageTitle: "",
  },
  "traveller.info.gender.input.label": {
    message: "Gender",
    messageTitle: "",
  },
  "traveller.info.date.of.birth.input.label": {
    message: "Date of birth",
    messageTitle: "",
  },
  "traveller.info.email.input.label": {
    message: "Email",
    messageTitle: "",
  },
  "traveler.info.country.placeholder": {
    message: "Select country",
    messageTitle: "",
  },
  "traveler.info.country.frequent.label": {
    message: "Program Name",
    messageTitle: "",
  },
  "traveller.info.country.code.input.label": {
    message: "Country Code",
    messageTitle: "",
  },
  "traveller.info.mobile.input.placeholder": {
    message: "Enter phone number",
    messageTitle: "",
  },
  "traveller.info.mobile.input.label": {
    message: "Phone Number",
    messageTitle: "",
  },
  "traveller.info.select.country.input.label": {
    message: "Issuing Country",
    messageTitle: "",
  },
  "traveler.document.number.input.label": {
    message: "Passport Number",
    messageTitle: "",
  },
  "traveller.frequent.flyter.input.label": {
    message: "Frequent Flyer Number",
    messageTitle: "",
  },
  "traveller.precheck.input.label": {
    message: "TSA PreCheck Number / Pass ID",
    messageTitle: "",
  },
  "traveller.mealtype.input.label": {
    message: "Meal Type",
    messageTitle: "",
  },
  "traveler.info.contact.label": {
    message: "Contact Info",
    messageTitle: "",
  },
  "traveller.email.or.phone.error": {
    message: "REQUIRED",
    messageTitle: "",
  },
  "traveler.select.country.placeholder": {
    message: "Select country",
    messageTitle: "",
  },
  "traveler.frequent.placeholder": {
    message: "None selected",
    messageTitle: "",
  },
  "traveler.password.heading": {
    message: "TSA PreCheck / Redress Number",
    messageTitle: "OPTIONAL",
  },
  "traveler.meal.heading": {
    message: "Meal Preferences",
    messageTitle: "OPTIONAL",
  },
  "traveler.meal.placeholder": {
    message: "No preference",
    messageTitle: "",
  },
  "traveler.yyyy.label": {
    message: "YYYY",
    messageTitle: "",
  },
  "traveler.dd.label": {
    message: "DD",
    messageTitle: "",
  },
  "traveler.month.label": {
    message: "Month",
    messageTitle: "",
  },
  "traveler.select.label": {
    message: "Select",
    messageTitle: "",
  },
  "traveler.email.placeholder": {
    message: "Enter email address",
    messageTitle: "",
  },
  //airport
  "airport.search.failure.400": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.401": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.402": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.403": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.404": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.500": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.501": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.502": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.503": {
    message:
      "Sorry, we are unable to search for airports at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "airport.search.failure.504": {
    message: "Sorry, our system is too busy at this time to search for airports. Please try again later.",
    messageTitle: "OOPS",
  },

  //category
  "category.details.failure.400": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "category.details.failure.401": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "category.details.failure.402": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "category.details.failure.403": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "category.details.failure.404": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "category.details.failure.500": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "category.details.failure.501": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "category.details.failure.502": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "category.details.failure.503": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "category.details.failure.504": {
    message: "Sorry, our system is too busy at this time to retrieve these details. Please try again later.",
    messageTitle: "OOPS",
  },
  // config
  "config.details.failure.400": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "config.details.failure.401": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "config.details.failure.402": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "config.details.failure.403": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "config.details.failure.404": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "config.details.failure.500": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "config.details.failure.501": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "config.details.failure.502": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "config.details.failure.503": {
    message:
      "Sorry, we are unable to configure your preferences at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "config.details.failure.504": {
    message: "Sorry, our system is too busy at this time to configure your preferences. Please try again later.",
    messageTitle: "OOPS",
  },
  //prompt
  "prompt.details.failure.400": {
    message:
      "Sorry, we are unable to process your query at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.401": {
    message:
      "Sorry, we are unable to process your query at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.402": {
    message:
      "Sorry, we are unable to process your query at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.403": {
    message:
      "Sorry, we are unable to process your query at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.404": {
    message:
      "Sorry, we are unable to process your query at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.500": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.501": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.502": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.503": {
    message:
      "Sorry, we are unable to access the information you're looking for. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "prompt.details.failure.504": {
    message: "Sorry, our system is too busy at this time to retrieve these details. Please try again later.",
    messageTitle: "OOPS",
  },
  // dayplanning.details
  "booking.details.shared.success": {
    message: "Booking details shared successfully",
    messageTitle: "Success",
  },
  "itinerary.share.success": {
    message: "Itinerary is shared",
    messageTitle: "Success",
  },
  "itinerary.saved.success": {
    message: "Your itinerary is saved!",
    messageTitle: "Success",
  },
  "failed.fetch.room.details": {
    message: "Unable to fetch room details",
    messageTitle: "OOPS",
  },
  "shared.cart.load.failed": {
    messageTitle: "This cart couldn't be loaded",
    message: "We searched again for the same place, dates and travelers.",
  },
  "shared.cart.open.failed": {
    messageTitle: "This cart couldn't be opened",
    message: "Please start a new search.",
  },
  "checkout.room.unavailable": {
    messageTitle: "Room no longer available",
    message: "The room selected is no longer available. What would you like to do?",
  },
  "checkout.seat.unavailable": {
    messageTitle: "Seat no longer available",
    message: "The seat selected is no longer available. What would you like to do?",
  },
  "checkout.unavailable.other.options": {
    message: "See other options",
    messageTitle: "",
  },
  "checkout.unavailable.new.trip": {
    message: "Plan new trip",
    messageTitle: "",
  },
  "itinerary.id.missing": {
    message: "Unable to fetch room details",
    messageTitle: "OOPS",
  },
  "empty.name.save.itinerary": {
    message: "Please enter trip name!",
    messageTitle: "",
  },
  "regenerating.itinerary": {
    message: "Regenerating ...",
    messageTitle: "",
  },
  "generating.itinerary": {
    message: "Generating ...",
    messageTitle: "",
  },
  "dayplanning.details.failure.400": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and please contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.401": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.402": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.403": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.404": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.500": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.501": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.502": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.503": {
    message:
      "Sorry, we were unable to create your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "dayplanning.details.failure.504": {
    message: "Sorry, our system is too busy at this time to load your itinerary. Please try again later.",
    messageTitle: "OOPS",
  },
  // delete.history
  "delete.history.failure.400": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.401": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.402": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.403": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.404": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.500": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.501": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.502": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.503": {
    message:
      "Sorry, we were unable to delete your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.history.failure.504": {
    message: "Sorry, our system is too busy at this time to delete your history. Please try again later.",
    messageTitle: "OOPS",
  },
  //viewfrequenttrip
  "view.history.failure.400": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "view.history.failure.401": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "view.history.failure.402": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "view.history.failure.403": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "view.history.failure.404": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "view.history.failure.500": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "view.history.failure.501": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "view.history.failure.502": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "view.history.failure.503": {
    message:
      "Sorry, we were unable to load your history at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "view.history.failure.504": {
    message: "Sorry, our system is too busy at this time to load your history. Please try again later.",
    messageTitle: "OOPS",
  },
  // itinerary.details
  "itinerary.details.failure.400": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.401": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.402": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.403": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.404": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.500": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.501": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.502": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.503": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.details.failure.504": {
    message: "Sorry, our system is too busy at this time to load your itinerary. Please try again later.",
    messageTitle: "OOPS",
  },
  //itinerary.list
  "itinerary.list.failure.400": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.401": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.402": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.403": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.404": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.500": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.501": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.502": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.503": {
    message:
      "Sorry, we were unable to load your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "itinerary.list.failure.504": {
    message: "Sorry, our system is too busy at this time to load your itinerary. Please try again later.",
    messageTitle: "OOPS",
  },
  // Baggage and fare rules

  "baggage.fare.failure.400": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.401": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.402": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.403": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.404": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.500": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.501": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.502": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.503": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "baggage.fare.failure.504": {
    message:
      "Sorry, we are unable to get baggage rules at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },

  // select fare
  "fare.loader": {
    message: "Review and select fare",
    messageTitle: "",
  },
  "select.fare.failure.400": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "select.fare.failure.401": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "select.fare.failure.402": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "select.fare.failure.403": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "select.fare.failure.404": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "select.fare.failure.500": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "select.fare.failure.501": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "select.fare.failure.502": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "select.fare.failure.503": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },
  "select.fare.failure.504": {
    message:
      "Sorry, we are unable to fetch fairs at this time. Please try again and contact support if the issue persists",
    messageTitle: "OOPS",
  },

  "baggage.fare.error": {
    message: "An error occurred while fetching data.",
    messageTitle: "OPPS",
  },
  "fare.details.error": {
    message: "Failed to fetch fare details",
    messageTitle: "Sorry",
  },

  //recommended.list
  "recommended.list.failure.400": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.401": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.402": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.403": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.404": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.500": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.501": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.502": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.503": {
    message:
      "Sorry, we were unable to load recommendations at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "recommended.list.failure.504": {
    message: "Sorry, our system is too busy at this time to load recommendations. Please try again later.",
    messageTitle: "OOPS",
  },
  //weather.details
  "weather.details.failure.400": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.401": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.402": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.403": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.404": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.500": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.501": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.502": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.503": {
    message:
      "Sorry, we were unable to load weather details at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "weather.details.failure.504": {
    message: "Sorry, our system is too busy at this time to load weather details. Please try again later.",
    messageTitle: "OOPS",
  },
  //saveitinerary.details
  "saveitinerary.details.failure.400": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.401": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.402": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.403": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.404": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.500": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.501": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.502": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.503": {
    message:
      "Sorry, we were unable to save your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "saveitinerary.details.failure.504": {
    message: "Sorry, our system is too busy at this time to save your itinerary. Please try again later.",
    messageTitle: "OOPS",
  },

  // delete.itinerary
  "delete.itinerary.failure.400": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.401": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.402": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.403": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.404": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and contact support if the issue persists.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.500": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.501": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.502": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.503": {
    message:
      "Sorry, we were unable to delete your itinerary at this time. Please try again and know our team is working to fix this.",
    messageTitle: "OOPS",
  },
  "delete.itinerary.failure.504": {
    message: "Sorry, our system is too busy at this time to delete your itinerary. Please try again later.",
    messageTitle: "OOPS",
  },
  "flight.search.failure": {
    message: "Sorry, we were unable to process your request. Please try again.",
    messageTitle: "OOPS ",
  },
  "flights.and.hotel.data.notfound": {
    message: "Flight and hotel data not available!",
    messageTitle: "OOPS",
  },
  "select.flights.to.modify": {
    message: "Select flights to modify",
    messageTitle: "",
  },
  "hotel.search.failure": {
    message:
      "Sorry, there are no available flights that match your search criteria. Please adjust your preferences and try again.",
    messageTitle: "OOPS",
  },
  "hotel.availability.failure": {
    message: " Sorry, the selected hotel is no longer available. Please select another hotel or search again.",
    messageTitle: "OOPS",
  },
  "traveller.info.invalid.year": {
    message: "The birth year you entered is invalid. Please correct it and try again.",
    messageTitle: "OOPS",
  },

  // Benefit Banner
  "data.security.banner": {
    message: "Your data will only be processed by certified providers.",
    messageTitle: "Data security is guaranteed",
  },

  //Authentication
  "login.reminder.note": {
    message: "Don't lose your work!",
    messageTitle: "",
  },
  "login.reminder.subnote": {
    message: "To save your search history, book hotels and flights and do much more,",
    messageTitle: "",
  },
  "invalid.email": {
    message: "Enter a valid email address",
    messageTitle: "",
  },
  "password.field.empty": {
    message: "Password field cannot be empty.",
    messageTitle: "",
  },
  "login.required": {
    message: "We require a login to access this feature.",
    messageTitle: "",
  },
  //Account Creation
  "user.details.notfound": {
    message: "Sorry, we were unable to process your request. Please try again.",
    messageTitle: "OOPS",
  },
  "password.uppercase": {
    message: "1 UPPERCASE letter",
    messageTitle: "",
  },
  "password.lowercase": {
    message: "1 lowercase letter",
    messageTitle: "",
  },
  "password.number": {
    message: "1 number",
    messageTitle: "",
  },
  "password.special": {
    message: "1 special character",
    messageTitle: "",
  },
  "password.length": {
    message: "At least 8 characters",
    messageTitle: "",
  },
  "password.validation.regex": {
    message:
      "Password must contain at least 1 uppercase, 1 lowercase, 1 number, 1 special character, and be at least 8 characters long.",
    messageTitle: "",
  },
  "password.update.success": {
    message: "Password updated, return to previous tab to continue.",
    messageTitle: "Success",
  },
  "save.itinerary.note": {
    message: "Save itinerary",
    messageTitle: " ",
  },
  "save.itinerary.input.placeholder": {
    message: "Greek Islands",
    messageTitle: " ",
  },
  "save.itinerary.input.label": {
    message: "TRIP NAME",
    messageTitle: " ",
  },
  "save.itinerary.label": {
    message: "SAVE ITINERARY",
    messageTitle: " ",
  },
  //edit activity
  "edit.activity.note": {
    messageTitle: "OOPS",
    message: "Edit Activities",
  },
  "edit.activity.input.placeholder": {
    messageTitle: "",
    message: "\nAdd an activity here",
  },
  "shareItinerary.success": {
    messageTitle: "SUCCESS!",
    message: "Your itinerary has been shared!",
  },
  "reset.password.input.field.placeholder": {
    message: "Enter your new password",
    messageTitle: "",
  },
  "confirm.reset.password.input.field.placeholder": {
    message: "Confirm your new password",
    messageTitle: "",
  },
  "mcp.continue.loading": {
    message: "Opening your booking...",
    messageTitle: "",
  },
  "mcp.continue.not.found": {
    message: "This link no longer works. Go back to your chat to book again.",
    messageTitle: "",
  },
  "mcp.continue.too.many": {
    message: "Too many tries. Wait a minute, then reload this page.",
    messageTitle: "",
  },
  "mcp.continue.failed": {
    message: "Something went wrong. Reload this page to try again.",
    messageTitle: "",
  },
  "mcp.continue.account.choice": {
    message: "You are signed in as {current}. This link is for {next}.",
    messageTitle: "",
  },
  "mcp.continue.as": {
    message: "Continue as {next}",
    messageTitle: "",
  },
  "mcp.continue.stay": {
    message: "Stay as {current}",
    messageTitle: "",
  },
  "api.error": {
    message: "Sorry, we were unable to process your request. Please try again.",
    messageTitle: "OOPS",
  },
  "captcha.verification.failed": {
    message: "Captcha verification failed. Please try again!",
    messageTitle: "OOPS",
  },
  "travellers.room.count.error": {
    message: "You can select up to 9 rooms",
    messageTitle: "",
  },
  "flight.travellers.count.error": {
    message: "* Each infant must be accompanied by one adult",
    messageTitle: "",
  },
  "flight.details.failure": {
    message: "Having trouble getting flight details. Please try again later!",
    messageTitle: "Sorry",
  },
  "baggage.failure": {
    message: "having trouble getting baggage and fare rule details. Please try again later!",
    messageTitle: "Sorry",
  },
  "booking.success": {
    message: "Your booking has been completed successfully, with the confirmation number below.",
    messageTitle: "Booking Complete!",
  },
  "booking.inprogress": {
    message: "Your booking is inprogress, with the confirmation number below.",
    messageTitle: "Booking inprogress!",
  },
  "booking.confirmation.booked": {
    message: "Thank you! We’ve confirmed your booking.",
    messageTitle: "Your trip is booked",
  },
  "booking.confirmation.inprogress": {
    message: "Thank you! We’ve received your payment. Once it’s confirmed, confirmation will be emailed to ",
    messageTitle: "Booking in progress",
  },
  "booking.confirmation.email": {
    message: "The confirmation will be emailed to",
    messageTitle: "",
  },
  "booking.confirmation.mytrips": {
    message: "Meanwhile, please go to My Trips to see your booking details.",
    messageTitle: "",
  },
  "booking.confirmation.happy.travels": {
    message: "Happy travels!",
    messageTitle: "",
  },
  "booking.confirmation.card.booked": {
    message: `${_brandManifest.name} confirmation number:`,
    messageTitle: "Booking Confirmation",
  },
  "booking.confirmation.card.inprogress": {
    message: `${_brandManifest.name} itinerary number:`,
    messageTitle: "Trip Information",
  },
  "booking.confirmation.go.to.trip": {
    message: "Go to trip",
    messageTitle: "",
  },
  "booking.confirmation.plan.new.trip": {
    message: "Plan new trip",
    messageTitle: "",
  },
  "book.failure": {
    message:
      "Sorry, we are having trouble completing your booking at this time.  We will contact you to help with  your booking shortly",
    messageTitle: "OOPS",
  },
  "link.expired": {
    message: "Password reset link has expired. Try requesting a new one.",
    messageTitle: "",
  },
  "login.failure": {
    message: "Invalid credentials! Please try again with correct credentials!",
    messageTitle: "Sorry",
  },
  "logout.success": {
    message: "Logged out successfully",
    messageTitle: "SUCCESS",
  },
  "account.creation.invalid.name": {
    message: "",
    messageTitle: "Please enter your name",
  },
  "account.creation.invalid.email": {
    message: "Please enter valid email address",
    messageTitle: "",
  },
  "invalid.phone": {
    message: "Invalid phone number",
    messageTitle: "",
  },
  "email.place.holder": {
    message: "Enter your email",
    messageTitle: "",
  },
  "password.place.holder": {
    message: "Enter password",
    messageTitle: "",
  },
  "forget.password": {
    message: "Forgot your password?",
    messageTitle: "",
  },
  "first.and.Last.placeholder": {
    message: "enter your first and last name",
    messageTitle: "",
  },
  "account.creation.email.exist": {
    message: "Email id already exist",
    messageTitle: "",
  },
  "forget.password.invalid.email": {
    message: "Please enter valid email address",
    messageTitle: "",
  },
  "forget.password.Input.placeholder": {
    message: "Enter your email address",
    messageTitle: "",
  },
  "forget.password.email.sent.success": {
    message: "Reset password link sent to your email, please check your email inbox!",
    messageTitle: "SUCCESS",
  },
  "SaveItinerary.inputFieldEnter": {
    message: "Please type your message before hitting send!",
    messageTitle: "Please",
  },
  "SaveItinerary.inputFieldLoad": {
    message: "Processing your previous request. Either cancel or your previous request to wait it to complete!",
    messageTitle: "Please wait!",
  },
  "SaveItinerary.destinationError": {
    message: "Having trouble with parsing JSON data. Please try again later!",
    messageTitle: "Sorry",
  },
  "ModifyingActivity.loading": {
    message: "Saving modified activity...",
    messageTitle: "Loading",
  },
  "ModifyingActivity.editSuccessWithUserLogin": {
    message: "Modified activity is saved",
    messageTitle: "SUCCESS",
  },
  "ModifyingActivity.editSuccessWithoutUserLogin": {
    message: "Activity is modified!",
    messageTitle: "SUCCESS",
  },
  "PostBooking.flightChangeRequest": {
    message: "Your request has been submitted. We will contact you with next steps.",
    messageTitle: "SUBMITTED",
  },
  "PostBooking.flightCancelRequest": {
    message: "Your request has been submitted. We will contact you with next steps.",
    messageTitle: "SUBMITTED",
  },
  // "NewMyTripsCancel & Modify" — flight CANCEL error toasts (handleCustomError(status, "cancel.flight"))
  "cancel.flight.failure.404": {
    messageTitle: "OOPS",
    message:
      "Sorry, we couldn't find this booking. Please refresh and try again, and contact support if the issue persists.",
  },
  "cancel.flight.failure.409": {
    messageTitle: "OOPS",
    message: "A cancellation request is already in progress for this booking. Please check back shortly.",
  },
  "cancel.flight.failure.422": {
    messageTitle: "OOPS",
    message: "This round-trip booking can only be cancelled in full, or one or more flights are already cancelled.",
  },
  "cancel.flight.failure.500": {
    messageTitle: "OOPS",
    message:
      "Sorry, we couldn't process your cancellation right now. Please try again and know our team is working to fix this.",
  },
  // "NewMyTripsCancel & Modify" — flight MODIFY error toasts (handleCustomError(status, "modify.flight"))
  "modify.flight.failure.404": {
    messageTitle: "OOPS",
    message:
      "Sorry, we couldn't find this booking or flight. Please refresh and try again, and contact support if the issue persists.",
  },
  "modify.flight.failure.409": {
    messageTitle: "OOPS",
    message: "A change request is already in progress for this booking. Please check back shortly.",
  },
  "modify.flight.failure.422": {
    messageTitle: "OOPS",
    message:
      "Sorry, this change isn't possible - the new dates create too short a connection between flights. Please pick different dates.",
  },
  "modify.flight.failure.500": {
    messageTitle: "OOPS",
    message:
      "Sorry, we couldn't process your change right now. Please try again and know our team is working to fix this.",
  },
  "PostBooking.hotelChangeRequest": {
    message: "Your request has been submitted. Hotel change request is in progress",
    messageTitle: "SUBMITTED",
  },
  "PostBooking.hotelChangeRequestFailure": {
    message: "Hotel change request failed",
    messageTitle: "Sorry",
  },
  "PostBooking.hotelCancelRequestFailure": {
    message: "Hotel concellation failed.",
    messageTitle: "Sorry",
  },
  "PostBooking.hotelSearchDateValidationFailure": {
    message: "CheckOut dates should be greater than CheckIn dates",
    messageTitle: "Sorry",
  },
  "PostBooking.hotelSearchSameDateError": {
    message: "Please enter different checkout date",
    messageTitle: "Sorry",
  },
  "airport.from.label": {
    message: "From",
    messageTitle: "",
  },
  "airport.to.label": {
    message: "To",
    messageTitle: "",
  },
  "range.label": {
    message: "Departure",
    messageTitle: "",
  },
  "booking.input.fieldnote": {
    message: "We will search for hotels after flight selection",
    messageTitle: "",
  },
  "traveller.field.missing": {
    message: "At least 1 adult or senior is required",
    messageTitle: "",
  },
  "traveller.child.error": {
    message: "A child must be accompanied by at least 1 adult or senior.",
    messageTitle: "",
  },
  //fill required fields
  "fill.required.fields": {
    message: "Please fill required fields",
    messageTitle: "",
  },
  "traveller.city.error": {
    message: "Please select a cities to search",
    messageTitle: "",
  },
  "arrival.and.departure.airport.error": {
    message: "Arrival and departure airports cannot be the same",
    messageTitle: "",
  },
  "duplicate.fight.error": {
    message: "Multiple same departure and arrival on same date not allowed",
    messageTitle: "",
  },
  "duplicate.stay.error": {
    message: "Multiple same location and check-in, check-out are not allowed",
    messageTitle: "",
  },
  "arrival.departureDate.Same.Error": {
    message: "Please make sure departure dates are in correct order.",
    messageTitle: "OPPS",
  },
  "invalid.trip.type": {
    message: "Invalid trip type.",
    messageTitle: "",
  },
  "empty.traveller.error": {
    message: "At least 1 adult or senior is required.",
    messageTitle: "",
  },
  //Edit Account
  "profile.update.success": {
    message: "Your profile is updated!",
    messageTitle: "",
  },
  "profile.update.in.progress": {
    message: "Please wait while we upload your profile picture",
    messageTitle: "",
  },
  "profile.update.failure": {
    message: "OOPS",
    messageTitle: "Sorry, we were unable to process your request. Please try again.",
  },
  "remove.profile.picture": {
    message: "Remove profile picture",
    messageTitle: "",
  },
  "your.name": {
    message: "Full name",
    messageTitle: "",
  },
  "email.address": {
    message: "Email",
    messageTitle: "",
  },
  "email.placeholder": {
    message: "EMAIL ADDRESS",
    messageTitle: "",
  },
  "phone.number.placeholder": {
    message: "(123) 456-7890",
    messageTitle: "",
  },
  "profile.picture.delete.success": {
    message: "Profile picture is deleted successfully",
    messageTitle: "Success!",
  },
  "verify.email.success": {
    message: "Thank you for verifying your email!",
    messageTitle: "",
  },

  //feedback
  "feedback.success": {
    messageTitle: "SUCCESS!",
    message: "Your feedback has been submitted successfully.",
  },
  "feedback.failure": {
    messageTitle: "OOPS",
    message: "Having trouble submitting your feedback. Please try again later!",
  },

  //Reviewa
  "no.hotel.reviews.found": {
    messageTitle: "Sorry",
    message: "Having trouble with getting Hotel reviews. Please try again later!",
  },

  //server response messages

  "client.side.400": {
    messageTitle: "OOPS",
    message: "The request is invalid or cannot be processed.",
  },
  "client.side.401": {
    messageTitle: "OOPS",
    message: "You are not authorized to access this resource. Please log in and try again.",
  },
  "client.side.402": {
    messageTitle: "OOPS",
    message: "Please get the access to proceed.",
  },

  "client.side.403": {
    messageTitle: "OOPS",
    message: "You do not have permission to access this resource",
  },
  "client.side.404": {
    messageTitle: "OOPS",
    message: "The requested resource does not exist.",
  },
  "client.side.405": {
    messageTitle: "Method Not Allowed",
    message: "The request method is not supported.",
  },
  "server.side.500": {
    messageTitle: "OOPS",
    message: "A generic server-side error occurred.",
  },
  "server.side.501": {
    messageTitle: "OOPS",
    message: "The requested method is not supported.",
  },
  "server.side.502": {
    messageTitle: "OOPS",
    message: "The server received an invalid response from another server.",
  },

  "server.side.503": {
    messageTitle: "OOPS",
    message: "The server is currently unavailable.",
  },
  "server.side.504": {
    messageTitle: "OOPS",
    message: "The server timed out waiting for a response.",
  },
  "api.break.down": {
    message: "Something went wrong!",
    messageTitle: "Error",
  },
  "maintenance.message": {
    messageTitle: "We’ll Be Back Soon.",
    message:
      "Our site is undergoing scheduled maintenance. , Thanks for your patience—we’re working hard to improve your experience.",
  },
  "maintenance.corsError": {
    messageTitle: "We’ll Be Back Soon.",
    message:
      "Our site is undergoing scheduled maintenance. , Thanks for your patience—we’re working hard to improve your experience.",
  },
  "errorPage.networkError": {
    messageTitle: "NO INTERNET CONNECTION!\n",
    message: "Please check your connection and try again.",
  },
  "errorPage.incompatible.version": {
    messageTitle: "Incompatible app version detected.\n",
    message: "Please upgrade to the latest version for the best experience.",
  },
  "booking.select.flight": {
    messageTitle: "",
    message: "Please select flight",
  },
  "booking.select.stay": {
    messageTitle: "",
    message: "Please select stay",
  },
  "booking.no.hotel.selected": {
    messageTitle: "You have not selected a stay",
    message: "Are you sure you want to proceed without selecting a stay along with your flight?",
  },
  "booking.partial.hotel.selection": {
    messageTitle: "You have not selected a stay",
    message:
      // "You have selected hotels for {selected} of {total} cities. Would you like to continue selecting hotels for the remaining cities, or proceed to payment with your current selection?",
      "Are you sure you want to proceed without selecting {firstCityName}'s stay?",
  },
};

export const TOAST_MESSAGES = {
  BOOKING: {
    TravelerInfo: {
      invalidDate: {
        type: ToastType.ERROR,
        messageTitle: "",
        message: "Invalid Date of Birth. Please enter correct Date and try again!",
      },
      invalidYear: {
        type: ToastType.ERROR,
        messageTitle: "",
        message: "Invalid Year for Date of Birth. Please enter correct Year and try again!",
      },
    },
  },
  TravelerInfoInputFiledNoData: {
    type: ToastType.ERROR,
    messageTitle: "Sorry",
    message: "No data found",
  },
};

//update messages from API
export const updateToastMessages = (fetchedMessages: any[]) => {
  fetchedMessages.forEach((msg) => {
    Messages[msg.key] = {
      message: msg.value,
      messageTitle: msg.title,
    };
  });
};
